<template>
  <van-collapse v-model="activeName" accordion>
    <van-collapse-item
      v-for="(item, index) in list"
      :name="index"
      :key="index"
      :title="item.name"
    >
      <div class="content">
        <div class="list">
          <span class="list-left">数量</span>
          <span class="list-right">{{ item.drawLotsNumber }}</span>
        </div>
        <div class="list">
          <span class="list-left">当前库存</span>
          <span class="list-right">{{ item.surplusNum }}</span>
        </div>
        <div class="list">
          <span class="list-left">获得概率</span>
          <span class="list-right">{{ item.drawLotsProb }}</span>
        </div>
        <div class="list">
          <span class="list-left">状态</span>
          <span class="list-right">{{ item.status }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeName: [],
    };
  },
};
</script>
<style lang="stylus" scoped>
.content {
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    color: #999999;
    font-size: 14px;
    .list-right {
      position relative
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 230px;
      flex-wrap: wrap;
      color: #333333;
    }
  }
}
</style>
